import ModalReferenceFormModule from './containers/modalReferenceFormModule'

export {default as ModalReferenceFormModuleLayout} from './components/modalReferenceFormModuleLayout'

export default ModalReferenceFormModule
